import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewChildren} from '@angular/core';
import {
  ClarityIcons, cogIcon, crosshairsIcon, gridViewIcon, pencilIcon, plusIcon, minusIcon, stepForwardIcon, refreshIcon,
  networkSettingsIcon, recycleIcon, organizationIcon, heatMapIcon, angleIcon, arrowIcon, calendarIcon, chatBubbleIcon,
  checkCircleIcon, checkboxListIcon, windowCloseIcon, dashboardIcon, downloadIcon, downloadCloudIcon, errorStandardIcon,
  exclamationCircleIcon, exclamationTriangleIcon, helpIcon, infoCircleIcon, linkIcon, nodeGroupIcon, noteIcon, pinIcon,
  radarIcon, tagIcon, tagsIcon, timesCircleIcon, trashIcon, treeViewIcon, twoWayArrowsIcon, uploadIcon, zoomInIcon,
  zoomOutIcon, worldIcon, bugIcon, networkSwitchIcon, playIcon, pauseIcon, sunIcon, moonIcon, clipboardIcon, floppyIcon,
  undoIcon, firewallIcon, banIcon, computerIcon, clockIcon, checkIcon,
} from '@cds/core/icon';
import '@cds/core/icon/register.js';
ClarityIcons.addIcons(crosshairsIcon, gridViewIcon, pencilIcon, plusIcon, minusIcon, cogIcon, stepForwardIcon, refreshIcon,
  networkSettingsIcon, recycleIcon, organizationIcon, heatMapIcon, angleIcon, arrowIcon, calendarIcon, chatBubbleIcon,
  checkCircleIcon, checkboxListIcon, windowCloseIcon, cogIcon, crosshairsIcon, dashboardIcon, downloadIcon,
  downloadCloudIcon, errorStandardIcon, exclamationCircleIcon, exclamationTriangleIcon, heatMapIcon, helpIcon,
  infoCircleIcon, linkIcon, networkSettingsIcon, nodeGroupIcon, noteIcon, organizationIcon, pencilIcon, pinIcon,
  radarIcon, recycleIcon, refreshIcon, stepForwardIcon, tagIcon, tagsIcon, timesCircleIcon, trashIcon, treeViewIcon,
  twoWayArrowsIcon, uploadIcon, zoomInIcon, zoomOutIcon, windowCloseIcon, worldIcon, bugIcon, networkSwitchIcon,
  playIcon, pauseIcon, sunIcon, moonIcon, clipboardIcon, floppyIcon, undoIcon, firewallIcon, banIcon, computerIcon,
  clockIcon, checkIcon);

import {
  LastReleaseInfo,
  NetscopeApiService,
  Success,
  Response
} from "@app/services/netscope-api.service";
import {
  ClusterFlowDetails,
  ComboboxSelectionItem,
  ComputingResourceCollection, DCNetscopeResourceWithName,
  DuckDbDashboardData,
  DuckDbResourceObject,
  FlowRessourceObject,
  HostSystem,
  TemporalParameter,
  VirtualMachine, UserInfo, TelemetryPushInfo, TelemetryInfo, SearchableComboboxSelectionItem,
  appsGroupFilterReference, appsGroupFilterResource
} from "@app/netscope/model/data-models";
import {of, Subscription, throwError} from "rxjs";
import {NetscopeUiService} from "@app/services/netscope-ui.service";
import {DuckDbServiceWithInBrowserDuckDb, DuckDbServiceWithRemoteDuckDb} from "@app/services/duck-db.service";
import {take} from 'rxjs';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ActivatedRoute, NavigationEnd, NavigationExtras, Params, Router} from "@angular/router"
import {dayStart, addDay} from "@formkit/tempo";
import {catchError, filter} from "rxjs/operators";
import {SelectionComboboxComponent} from "@app/selection-combobox/selection-combobox.component";
import {NetscopeUtils} from "@app/netscope/netscope-utils";
import {environment} from "../../environments/environment";
import {FlowRepositorySearch} from "@app/netscope/model/flows-repository";
import {FortinetNavService} from "@app/fortinet/fortinet-shared";
import {FortinetDevicesService} from "@app/fortinet/fortinet-nav.component";
import {ThemeMode, ThemeService} from "@app/services/theme.service";

@Component({
  standalone: false,
  selector: 'app-dcnetscope-main',
  templateUrl: './dcnetscope-main.component.html',
  styleUrl: './dcnetscope-main.component.css'
})
export class DcnetscopeMainComponent implements OnInit, OnDestroy {
  // Selected view can be "Protocols analysis", "Dependencies viewer", "Clusters Viewer" or "Apps Groups"
  viewLabel = "dashboard.name";
  iconShape = "dashboard";

  openHeatmapModal: boolean = false;

  startTime = 0;
  endTime = 0;
  temporalParameter: TemporalParameter;
  timeResolution = "hourly";
  fromDate;
  toDate;
  customDateSelectionModalOpen = false;

  navigationEventSubscription: Subscription;

  @ViewChildren("combobox")
  comboboxes: SelectionComboboxComponent;

  failureMode = false;

  requestedTimeSelection = "last 1day";
  timeSelectionLabel: string = "";
  accountLabel = "Account";

  // comboboxSelectionItems: ComboboxSelectionItem[] = [];
  search: FlowRepositorySearch;

  currentComboboxSelection: ComboboxSelectionItem[] = [];
  vms: ComputingResourceCollection<VirtualMachine> = new ComputingResourceCollection<VirtualMachine>();
  hosts: ComputingResourceCollection<HostSystem> = new ComputingResourceCollection<HostSystem>();

  isLoading: boolean = false;
  isError: boolean = false;

  heatbeatInterval = undefined;
  checkUpdateInterval = undefined;

  eventCounter = 0;

  userinfo: UserInfo = undefined;
  telemetryinfo: TelemetryInfo = undefined;
  newReleaseInfo: LastReleaseInfo = undefined;

  public updateUrlRequestedEventEmitter: EventEmitter<string> = new EventEmitter();

  /* ---- Fortinet pages ----------------------------------------------------
     While a Fortinet page is open, its own menu (fortinet/fortinet-nav.component)
     replaces the flow menu. Everything about it lives in the fortinet folder. */
  /** a Fortinet page is open: its menu is shown instead of the flow menu */
  fortinetMenuShown = false;
  /** false once we know that no FortiGate has data: the Fortinet tab is grayed out */
  fortinetAvailable = true;
  private fortinetNavSubscription: Subscription;
  /** Label and icon of the page shown before the Fortinet page, put back
   *  when the user leaves it. */
  private labelBeforeFortinet: {viewLabel: string; iconShape: string} = undefined;

  constructor(private netscopeApiService: NetscopeApiService, private netscopeUiService: NetscopeUiService, private duckDbService: DuckDbServiceWithRemoteDuckDb, private ref: ChangeDetectorRef, private http: HttpClient, private router: Router, private activatedRouter: ActivatedRoute,
              private fortinetNav: FortinetNavService, private fortinetDevices: FortinetDevicesService,
              private themeService: ThemeService) {
  }

  ngOnInit() {

    // The theme service applies the saved theme (or the browser's one) as soon as it starts
    this.themeService.isLightTheme$.subscribe((isLight) => {
      this.isLightTheme = isLight;
    });
    this.themeService.mode$.subscribe((mode) => {
      this.themeMode = mode;
    });

    this.initVariablesFromUrlParameters();

    this.resetData();

    this.netscopeUiService.viewLabelChangeEmitter.subscribe((newViewLabel) => {
      this.viewLabel = newViewLabel;
    });

    this.netscopeUiService.iconShapeChangeEmitter.subscribe((newShape) => {
      this.iconShape = newShape;
    });

    this.netscopeUiService.loadingStateChangeEmitter.subscribe((newState) => {
      console.log(`detected new loading State: ${newState}`);
      this.isLoading = newState;
      this.askRefreshAngular();
    });

    this.netscopeUiService.errorStateChangeEmitter.subscribe((newState) => {
      console.log(`detected new error State: ${newState}`);
      this.isError = newState;
      if (this.isError) {
        this.isLoading = false;
      }
      this.askRefreshAngular();
    })

    this.netscopeUiService.selectedDateChangeEmitter.subscribe(([startTime, endTime, timeResolution]) => {
      if (this.startTime != startTime || this.endTime != endTime || this.timeResolution != timeResolution) {
        this.startTime = startTime;
        this.endTime = endTime;
        this.timeResolution = timeResolution;
        this.requestedTimeSelection = "custom";
        this.updateUrl();
        this.resetData();
      }
    })

    this.netscopeUiService.selectedResourcesChangeEmitter.subscribe((comboboxSelection) => {
      this.currentComboboxSelection = comboboxSelection;
      this.askRefreshAngular();
      this.updateUrl();
      this.duckDbService.recomputeDashboardData();
    });

    this.netscopeUiService.comboboxSelectionItemSubject.subscribe((event) => {
      this.updateUrl();
      this.duckDbService.recomputeDashboardData();
    });

    window.onresize = () => {
      this.netscopeUiService.onResizeEventEmitter.next(1);
    }

    const dashboardDataObservable = this.netscopeUiService.duckDbDataSubject
    dashboardDataObservable.subscribe((dashboardData: DuckDbDashboardData) => {
      this.onDashboardDataChange(dashboardData)
    });

    // The Fortinet page drives its own menu (see FortinetNavService).
    this.fortinetNavSubscription = this.fortinetNav.state$.subscribe((state) => {
      this.onFortinetNavState(state.active);
    });

    // Gray out the Fortinet tab when no FortiGate has data yet.
    this.fortinetDevices.hasDevices().subscribe((available) => {
      this.fortinetAvailable = available;
    });

    this.detectUsername();

    this.navigationEventSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log(event);
        this.updateUrl();
        this.eventCounter += 1;
    });

    // Heartbeat
    this.heatbeatInterval = setInterval(() => {
      this.netscopeApiService.callHeartBeat().subscribe((resp) => {
        console.log(`Heartbeat response: ${resp}`);
      });
    }, 30000);

    // Heartbeat
    let checkUpdate = () => {
      this.netscopeApiService.getPublishedUpdateInfos().subscribe((releaseInfo) => {
        this.netscopeApiService.getTelemetryInfo().subscribe((telemetryInfo) => {
          if (releaseInfo instanceof Success && telemetryInfo instanceof Success) {
            let remoteVersionInfo: LastReleaseInfo = releaseInfo.element;
            let localVersionInfo: TelemetryInfo = telemetryInfo.element;

            let localVersionStr = localVersionInfo.release;

            if (localVersionStr.split(".").length == 2) {
                localVersionStr += ".0";
            }

            let remoteVersionStr = remoteVersionInfo.version;
            if (remoteVersionStr.split(".").length == 2) {
                remoteVersionStr += ".0";
            }

            let skipUpdate = false;
            let newReleaseStr = JSON.stringify(remoteVersionInfo);
            if (newReleaseStr != undefined && newReleaseStr.includes("skip_update")) {
                console.log("detected 'skip_update' in the release object : I will not download this update");
                skipUpdate = true;
            }

            const semver = require('semver')
            if (semver.gt(remoteVersionStr, localVersionStr) && !skipUpdate) {
              console.log("An update has been detected, I will propose to download it !");
              this.newReleaseInfo = remoteVersionInfo;
              // Fix markdown
               this.newReleaseInfo.message = this.newReleaseInfo.message.replaceAll("\\n", "\n");
            } else {
              console.log("No update detected.");
              this.newReleaseInfo = undefined;
            }
          }
        });
      });
    }
    this.checkUpdateInterval = setInterval(() => {
        checkUpdate();
    }, 60000);
    checkUpdate();
  }

  ngOnDestroy() {
    this.fortinetNavSubscription?.unsubscribe();
  }

  /** A Fortinet page opened (active: true) or closed: show the right menu, and
   *  put the right title in the bar. */
  private onFortinetNavState(active: boolean) {
    const arriving = active && !this.fortinetMenuShown;
    const leaving = !active && this.fortinetMenuShown;
    this.fortinetMenuShown = active;
    if (arriving) {
      this.onFortinetArrival();
    }
    if (leaving) {
      this.onFortinetDeparture();
    }
    // Out of the current change-detection pass: the Fortinet page
    // publishes its state while it renders.
    setTimeout(() => this.askRefreshAngular());
  }

  /** The user opened a Fortinet page: the bar names it, and its History
   *  window takes the bar's period. */
  private onFortinetArrival() {
    this.labelBeforeFortinet = {viewLabel: this.viewLabel, iconShape: this.iconShape};
    this.viewLabel = "fortinet.name";
    this.iconShape = "firewall";
    this.fortinetNav.sendTimeSelection(this.requestedTimeSelection, this.startTime, true);
  }

  /** The user left the Fortinet page: the previous label comes back, unless
   *  the next page has already set its own. */
  private onFortinetDeparture() {
    const before = this.labelBeforeFortinet;
    this.labelBeforeFortinet = undefined;
    if (before && this.viewLabel === "fortinet.name") {
      this.viewLabel = before.viewLabel;
      this.iconShape = before.iconShape;
    }
  }

  reloadBrowser = () => {
    window.location.reload();
  }

  updateUrl = () => {
    let params = new URLSearchParams(document.location.search);

    let origin = params.get("origin");
    let focusedResourcesUuids = [];
    let ignoredResourcesUuids = [];
    let focusedProtocols = [];
    let focusedAppsGroups = [];
    if ((origin != undefined && origin === "fromDatagrid") || this.eventCounter == 0) {
      focusedResourcesUuids = params.getAll("focusedResources");
      ignoredResourcesUuids = params.getAll("ignoredResources");
      focusedProtocols = params.getAll("focusedProtocols");
      focusedAppsGroups = params.getAll("focusedAppsGroups");
      this.initVariablesFromUrlParameters();
    } else {
      focusedResourcesUuids = this.currentComboboxSelection
          .filter((r) => r.mode !== "protocol")
          .filter((r) => r.mode !== "appgroup")
          .filter((r) => r.mode !== "ignore")
          .map((s) => s.resource.uuid);
      ignoredResourcesUuids = this.currentComboboxSelection
          .filter((r) => r.mode === "ignore")
          .map((s) => s.resource.uuid);
      focusedProtocols = this.currentComboboxSelection
          .filter((r) => r.mode === "protocol")
          .map((s) => s.resource.name);
      // An apps group is kept by its reference, which names its file as well
      focusedAppsGroups = this.currentComboboxSelection
          .filter((r) => r.mode === "appgroup")
          .map((s) => s.resource.uuid);
    }

    const queryParams: Params = {
      focusedResources: focusedResourcesUuids,
      ignoredResources: ignoredResourcesUuids,
      focusedProtocols: focusedProtocols,
      focusedAppsGroups: focusedAppsGroups,
    };

    if (this.requestedTimeSelection != undefined) {
      queryParams["requestedTimeSelection"] = this.requestedTimeSelection;

      if (this.requestedTimeSelection === "custom") {
        queryParams["startTime"] = this.startTime;
        queryParams["endTime"] = this.endTime;
      }
    }

    // The following block is in a setTimeout, to ensure that the change of URL is made 'asynchronously', to prevent
    // a page reload to fall back to the default (dashboard) URL. By setting 50 ms delay, the router will catch
    // the requested URL and redirect to the right component, and later, the URL is updated.
    setTimeout(() => {
      let navigationExtra: NavigationExtras = {
          relativeTo: this.activatedRouter,
          queryParams,
          queryParamsHandling: 'merge', // remove to replace all query params by provided
          state: {
              ignore: true,
          }
      };
      this.router.navigate(
        [document.location.pathname],
       navigationExtra
      );
    }, 50);

  }

  initVariablesFromUrlParameters = () => {

    let params = new URLSearchParams(document.location.search);
    let manuallyFocusedResourcesUuidsFromUrl = params.getAll("focusedResources")
      .filter((r) => r.startsWith("ip:") || r.startsWith("network:"));
    let focusedResourcesUuidsFromUrl = params.getAll("focusedResources")
      .filter((r) => ! (r.startsWith("ip:") || r.startsWith("network:")));
    let ignoredResourcesUuidsFromUrl = params.getAll("ignoredResources");
    let focusedProtocols = params.getAll("focusedProtocols");
    let focusedAppsGroups = params.getAll("focusedAppsGroups");
    let requestedTimeSelection = params.get("requestedTimeSelection");

    if (requestedTimeSelection != undefined) {
      this.requestedTimeSelection = requestedTimeSelection;
      if (requestedTimeSelection === "custom") {
        let startTime = params.get("startTime");
        let endTime = params.get("endTime");

        this.startTime = Number.parseFloat(startTime);
        this.endTime = Number.parseFloat(endTime);
      }
    }

    this.netscopeUiService.duckDbDataSubject.pipe(take(1)).subscribe((dashboardData) => {

      // The mode is part of the key: a resource ignored instead of focused is another selection
      let selectionKey = () => this.currentComboboxSelection.map((s) => `${s.mode}:${s.resource.uuid}`).join("__");
      let oldKey = selectionKey();
      this.currentComboboxSelection.splice(0);

      // Add selected resources from the URL parameters, the ones to focus on and the ones to ignore
      let resourceItem = (uuid: string, mode: string) => new ComboboxSelectionItem(
        new DCNetscopeResourceWithName(
          uuid,
          uuid.includes("vim.UnknownIpaddress") ? uuid.split(":")[1] : dashboardData.nodeMapping.get(uuid)?.name
        ),
        mode
      );
      this.currentComboboxSelection.push(...focusedResourcesUuidsFromUrl.map((uuid) => resourceItem(uuid, "focus")));
      this.currentComboboxSelection.push(...ignoredResourcesUuidsFromUrl.map((uuid) => resourceItem(uuid, "ignore")));

      // Add selected protocols from the URL parameters
      let newSelection2 = focusedProtocols.map((protocol) =>
        new ComboboxSelectionItem(
          new DCNetscopeResourceWithName(
            protocol,
            protocol
          ),
          "protocol"
        )
      );
      this.currentComboboxSelection.push(...newSelection2);

      // Add selected appsgroups from the URL parameters
      let newSelection3 = focusedAppsGroups.map((appGroupUuid) => {
        let reference = appsGroupFilterReference(appGroupUuid);
        return new ComboboxSelectionItem(
          reference.file === undefined
            ? new DCNetscopeResourceWithName(reference.name, reference.name)
            : appsGroupFilterResource({name: reference.name, file: reference.file, vms: []}),
          "appgroup"
        );
      });
      newSelection3.map((selection) => {
        selection.initManualSqlWhereClause(dashboardData);
      });
      this.currentComboboxSelection.push(...newSelection3);

      // Add selected resources from the URL parameters
      let newSelection4 = manuallyFocusedResourcesUuidsFromUrl.map((uuid) =>
        new ComboboxSelectionItem(
          new DCNetscopeResourceWithName(
            uuid,
            uuid.split(":")[1]
          ),
          "focus"
        )
      );
      newSelection4.map((selection) => {
        selection.initManualSqlWhereClause(dashboardData);
      });
      this.currentComboboxSelection.push(...newSelection4);

      let newKey = selectionKey();

      if (newKey !== oldKey) {
        this.netscopeUiService.comboboxSelectionItemSubject.next(this.currentComboboxSelection);
        this.requestReloadUI();
      }
    });
  }

  askRefreshAngular = () => {
    this.ref.detectChanges();
  }

  logout () {
    console.log("calling MainComponent.logout()");

    function handleError(error: HttpErrorResponse) {
        console.log("I will reload the browser");
        window.location.reload();
        return throwError(() => new Error('Asked to reload the browser (this error message is normal)'));
    }

      let httpResponseAsObservable = this.http.get("/oauth2/sign_out")
      .pipe(
        catchError(handleError)
      );
      httpResponseAsObservable.subscribe(() => {
        console.log("Got the response of the http request for sign-out");
      });
  }

  goToAdmin () {
    // @ts-ignore
    window.location = "/api/";
    this.router.navigateByUrl("/api/");
  }

  public detectUsername() {
    if (! environment.mockIdentity) {
      this.netscopeApiService.getUserInfo().subscribe((userInfoResponse) => {
        if (userInfoResponse instanceof Success) {

          this.userinfo = userInfoResponse.element;
          this.accountLabel = this.userinfo.preferred_username;

          // Send telemetry
          this.netscopeApiService.getTelemetryInfo().subscribe((telemetryInfoResponse) => {
            if (telemetryInfoResponse instanceof Success) {
              // @ts-ignore
              this.telemetryinfo = telemetryInfoResponse.element;
              let company = "unknown";
              if (this.userinfo.email.includes("@")) {
                company = this.userinfo.email.split("@")[1].toLowerCase().trim();
              }
              let telemetryPushInfo: TelemetryPushInfo = {
                  email: this.userinfo.email,
                  company: company,
                  application: this.telemetryinfo.application,
                  build: this.telemetryinfo.build,
                  expdate: this.telemetryinfo.expdate,
                  licensekey: this.telemetryinfo.licence_key,
                  productkey: this.telemetryinfo.product_key,
                  release: this.telemetryinfo.release,
                  vmclient: this.telemetryinfo.vmclient,
                  vmlicense: this.telemetryinfo.vmlicense
              };
              if (this.telemetryinfo.skip === 0) {
                this.netscopeApiService.sendTelemetry(telemetryPushInfo).subscribe((x) => {
                  console.log(x);
                });
              }
            }
          });
        }
      });
    }
  }

  resetData() {
    this.isLoading = true;
    let now = new Date();
    let today = dayStart(now);
    let yesterday = dayStart(addDay(now, -1));
    this.fromDate = yesterday;
    this.toDate = today;
    this.reloadData();
  }

  reloadData = () => {
    this.failureMode = false;
    this.netscopeUiService.setLoadingState(true, "main");
    this.isLoading = true;
    this.updateUrl();
    this.duckDbService.requestLoadingOfData(this.requestedTimeSelection, this.startTime, this.endTime);
  }

  onDashboardDataChange = (dashboardData: DuckDbDashboardData) => {
    this.isLoading = true;
    this.netscopeUiService.setLoadingState(true, "main");

    let startTime = dashboardData.selectedTimestamps[0];
    let endTime = dashboardData.selectedTimestamps[1];
    this.startTime = startTime;
    this.endTime = endTime;
    this.timeSelectionLabel = dashboardData.timeSelectionLabel;

    // POC: better handling of custom timeranges
    const start = new Date(startTime * 1000.0);
    const end = new Date((endTime + 59 * 60 + 59) * 1000.0); // TODO: find a better fix. It should be handled in the python API

    const formatter = new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });

    console.log(formatter.formatRange(start, end));
    this.timeSelectionLabel = formatter.formatRange(start, end);


    this.temporalParameter = new TemporalParameter(startTime, endTime, "hourly", this.requestedTimeSelection);

    this.netscopeUiService.temporalParametersSubject.next(this.temporalParameter);

    // let nodeMap: Map<string, FlowRessourceObject> = dashboardData.nodeMapping;

    // // Fix emitters_summary
    // for (let emitter of dashboardData.topEmitters) {
    //   if (dashboardData.nodeMapping.has(emitter.src_resource_uuid)) {
    //     let correspondingResource = dashboardData.nodeMapping.get(emitter.src_resource_uuid);
    //     emitter.name = correspondingResource.name;
    //   } else {
    //     emitter.name = emitter.src_resource_uuid.split(":")[1]
    //   }
    // }
    //
    // // Fix name of external Ips
    // for (let externalIp of dashboardData.externalIps) {
    //   if (nodeMap.has(externalIp.uuid)) {
    //     let correspondingExternalIp = nodeMap.get(externalIp.uuid);
    //     correspondingExternalIp.name = externalIp.name;
    //   }
    // }

    // this.netscopeUiService.threatsFlowDetailsSubject.next(dashboardData.threatsFlows);

    let clusterFlowsDetails = new ClusterFlowDetails();
    clusterFlowsDetails.dataUuid = dashboardData.dashboardDataUuid;

    this.netscopeUiService.clustersFlowDetailsSubject.next(clusterFlowsDetails);

    const dashboardGraphDataForFilterObservable = this.netscopeApiService.getDashboardGraphDataForFilter([], [], true);
    dashboardGraphDataForFilterObservable.subscribe((dashboardGraphDataForFilterResponse: Response<any>) => {

      let dashboardGraphDataForFilter;
      if (dashboardGraphDataForFilterResponse instanceof Success) {
        dashboardGraphDataForFilter = dashboardGraphDataForFilterResponse.element;
      }

      this.netscopeUiService.dashboardGraphDataSubject.next(dashboardGraphDataForFilter);
      // isLoading is updated by loadingStateChangeEmitter: the dashboard may still be loading its data
      this.netscopeUiService.setLoadingState(false, "main");
    });
    this.netscopeUiService.duckDbRefinedDataSubject.next(dashboardData);
    this.buildFilteringIndex();
  }

  buildFilteringIndex = async () => {
    this.netscopeUiService.duckDbRefinedDataSubject.pipe(take(1)).subscribe(async (data: DuckDbDashboardData) => {
      this.search = new FlowRepositorySearch(data.allFlowsRepository, data.appsGroups);
      this.search.init([]);
    });
  }

  fetchResourcesForCombobox = (filter = '', combobox: SelectionComboboxComponent) => {
    combobox.loadingResources = true;

    let narrowedResults = this.search.search(filter);
    combobox.asyncResources$ = of(narrowedResults);

    combobox.loadingResources = false;
  }

  onComboboxChange = (event) => {
    let processedSelection = this.currentComboboxSelection.filter((o) => o?.mode !== undefined);
    let newItemsInSelection = this.currentComboboxSelection.filter((o) => o?.mode === undefined);

    let processedNewItemsInSelection = newItemsInSelection.map((r) => new ComboboxSelectionItem(r.resource, "focus"));

    this.currentComboboxSelection = processedSelection.concat(processedNewItemsInSelection);

    event.model = this.currentComboboxSelection;

    this.netscopeUiService.comboboxSelectionItemSubject.next(this.currentComboboxSelection);
  }

  setCustomTimeSelection(fromDate, toDate) {
    this.requestedTimeSelection = "custom";
    this.timeResolution = "daily";
    this.startTime = fromDate.getTime() / 1000.0;
    this.endTime = toDate.getTime() / 1000.0;
    this.fortinetNav.sendTimeSelection(this.requestedTimeSelection, this.startTime, false);
    this.reloadData();
  }

  setTimeSelection(newTimeSelection) {
    this.requestedTimeSelection = newTimeSelection;
    this.fortinetNav.sendTimeSelection(this.requestedTimeSelection, this.startTime, false);
    this.reloadData();
  }

  requestReloadUI = () => {
    this.netscopeUiService.selectedResourcesChangeEmitter.emit(this.currentComboboxSelection);
  }

  requestUpdateURL = () => {
    this.updateUrlRequestedEventEmitter.emit();
  }

  setLanguage = (language: string) => {
    this.updateUrlRequestedEventEmitter.emit(language);
  }


  /* ---- Theme ---------------------------------------------------------------
     The choice (system, light, dark or automatic switch) is made in the Theme
     submenu of the settings dropdown and applied by ThemeService. */
  public isLightTheme = true;
  public themeMode: ThemeMode = 'system';
  public themeScheduleModalOpen = false;

  setThemeMode(mode: ThemeMode) {
    this.themeService.setMode(mode);
  }

  /** "Automatic switch..." opens the schedule dialog: the mode changes only when the schedule is saved */
  openThemeSchedule() {
    this.themeScheduleModalOpen = true;
  }

  /** Shown next to "Theme" in the settings dropdown */
  get themeModeLabel(): string {
    if (this.themeMode === 'light') {
      return 'Light';
    }
    if (this.themeMode === 'dark') {
      return 'Dark';
    }
    if (this.themeMode === 'schedule') {
      return 'Automatic';
    }
    return 'System';
  }

  /** Shown under "System default": the theme the browser asks for right now */
  get systemThemeLabel(): string {
    if (this.themeService.isSystemThemeLight()) {
      return 'light';
    }
    return 'dark';
  }

  /** Shown under "Automatic switch...", for instance "Light from 07:00 to 19:00" */
  get themeScheduleLabel(): string {
    const schedule = this.themeService.schedule$.value;
    return `Light from ${this.formatMinutes(schedule.lightAt)} to ${this.formatMinutes(schedule.darkAt)}`;
  }

  private formatMinutes(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return String(hours).padStart(2, '0') + ':' + String(rest).padStart(2, '0');
  }

  protected readonly environment = environment;
}
